<template>
  <!-- Example usage:
  <selectMultiLuRole
    v-model="selectedUser.UserRole" (the collection we are updating)
    selfKey="UserID" (how the selectedUser is referenced in the join item)
    :selfID="selectedUser.ID" (to create new entries we need the selected users ID)
    relatedItemKey="RoleID" (this is how the lookup is referenced in the join)
    joinItemName="UserRole" (this is the name of the join (for the js class))
  ></selectMultiLuRole>
-->
  <v-select
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :rules="rules"
    :loading="loading"
    chips
    deletable-chips
    multiple
    dense
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-select>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import CityCounty from '@classes/CityCounty'
import ExciseExceptions from '@classes/ExciseExceptions'
import ExciseTaxRateToCity from '@classes/ExciseTaxRateToCity'
export default {
  name: 'select-multi-join-luCity',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'City',
    },
    value: Array,
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: Array,
    items: Array,
    joinItemName: {
      type: String,
      required: true,
      //default: 'CityCounty',
      //default: 'ExciseExceptions',
      //default: 'ExciseTaxRateToCity',
    },
    relatedItemKey: {
      type: String,
      required: true,
      //default: 'CityID',
      //default: 'DeliveredToCityID',
      //default: 'CityID',
    },
    selfKey: {
      type: String,
      required: true,
    },
    selfID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      itemText: 'City',
      //itemText: 'DORJurisdiction',
    }
  },
  computed: {
    ...get('luCity', ['luCity', 'loading']),
    availableItems() {
      var list = []
      var fullList = []
      if (this.items) {
        fullList = this.items
        list = this.items.filter((i) => true)
      } else {
        fullList = this.luCity
        list = this.luCity.filter((i) => true)
      }
      //filter for only active items
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value > 0) {
        var selectedItem = fullList.find((i) => i.ID == this.value)
        if (!list.find((i) => i.ID == this.value) && selectedItem) {
          list.push(selectedItem)
        }
      }
      // sort by column
      // sort by column
      list.sort((a, b) => {
        //set the property to sort on
        let textField = this.itemText
        let sort = a[textField] > b[textField] ? 1 : -1
        return sort
      })
      return list
    },
    selected: {
      get() {
        if (this.value && this.value.length > 0) {
          return [
            ...new Set(this.value.map((item) => item[this.relatedItemKey])),
          ]
        } else {
          return []
        }
      },
      set(newValue) {
        if (this.value) {
          this.value.forEach((relation, index, object) => {
            if (!newValue.includes(relation[this.relatedItemKey])) {
              //need to remove item
              object.splice(index, 1)
            }
          })
          newValue.forEach((itemID) => {
            if (!this.value.find((i) => i[this.relatedItemKey] == itemID)) {
              // need to add item
              let item
              if (this.joinItemName == 'CityCounty') {
                item = new CityCounty()
              } else if (this.joinItemName == 'ExciseExceptions') {
                item = new ExciseExceptions()
              } else if (this.joinItemName == 'ExciseTaxRateToCity') {
                item = new ExciseTaxRateToCity()
              } else {
                item = {}
              }
              item[this.relatedItemKey] = itemID
              item[this.selfKey] = this.selfID
              this.value.push(item)
            }
          })
        }
      },
    },
  },
  created() {
    if (!this.items) {
      this.loadLuCity()
    }
  },
  methods: {
    loadLuCity: call('luCity/loadLuCity'),
  },
}
</script>
<style></style>
